import {Alpine as IAlpine} from 'alpinejs';

export default function (Alpine: IAlpine) {
  let header: HTMLElement | null = null;

  document.addEventListener('alpine:initialized', () => {
    header = document.querySelector<HTMLElement>('[x-ref="header"]');
  });

  Alpine.magic('scrollOffset', () => {
    if (header) {
      if ('offsetHeight' in header) {
        return header.offsetHeight;
      }
    }

    return 0;
  });
}
